module.exports = __webpack_public_path__ + "assets/media/folder-thumbnail.3d0c149e.svg";